// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__HAOYu","footer":"ChangeClinic_footer__15ZLs"};